import { render } from "./MilestoneComplete.vue?vue&type=template&id=e1b06168"
import script from "./MilestoneComplete.vue?vue&type=script&lang=js"
export * from "./MilestoneComplete.vue?vue&type=script&lang=js"

import "./MilestoneComplete.vue?vue&type=style&index=0&id=e1b06168&lang=css"

import exportComponent from "/builds/sites/smolke/app-kwispelcoach-com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__